export const asAngleLeft = {
  data: `<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.84667 1.18L6.66667 0L0 6.66667L6.66667 13.3333L7.84667 12.1533L2.36 6.66667L7.84667 1.18Z" fill="currentColor"/>
</svg>`,
  name: 'angle-left',
};
